import React from 'react';
import { capitalize } from 'lodash';
import moment from 'moment';

export function reportQRColumns({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      width: 60,
      filterable: false
    },
    {
      Header: t('reportPage_staffId'),
      accessor: 'staffId',
      filterable: false,
      width: 120,
    },
    {
      Header: t('reportPage_iin'),
      accessor: 'iin',
      width: 120,
      filterable: false,
    },
    {
      Header: t('reportPage_FIO'),
      accessor: 'iin',
      filterable: false,
      Cell: ({ original }) => <div>
        {original?.surname} {original?.name} {original?.middlename}
      </div>
    },
    {
      Header: t('reportPage_logDate'),
      accessor: 'logDate',
      filterable: false,
      width: 100,
      Cell: ({ original }) =>
        original.logDate
          ? moment(original.logDate).format('DD.MM.YYYY')
          : '',
    },
    {
      Header: t('reportPage_visitingTime'),
      accessor: 'visitingTime',
      filterable: false,
      width: 100,
      Cell: ({ original }) =>
        original.visitingTime
          ? moment(original.visitingTime).format('HH:mm')
          : '',
    },
    {
      Header: t('reportPage_serviceProviderId'),
      accessor: 'serviceProviderId',
      filterable: false,
      width: 120,
    },
    {
      Header: t('reportPage_serviceProviderName'),
      accessor: 'serviceProviderName',
      filterable: false,
      sortable: false,
      Cell: ({ original }) => original[`serviceProvider${capitalize(lang)}Name`]
    },
    {
      Header: t('reportPage_deviceUid'),
      accessor: 'deviceUid',
      filterable: false,
    },
    {
      Header: t('reportPage_deviceInfo'),
      accessor: 'deviceModelName',
      filterable: false,
    },
  ];
}
